"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveName = exports.resolveFileType = exports.resolveMime = void 0;
// import { data } from "./data";
var data_1 = require("./data");
var data = data_1.default
    .split("\n")
    .filter(function (_, index) { return index !== 0; })
    .map(function (row) {
    var cols = row.split(",");
    return {
        mime: cols[0],
        name: cols[1],
        fileType: cols[2]
    };
});
/**
 * Resolves Mime type (eg: text/csv, application/mp4 etc) of the mime to the specific mime.
 * @param mime MimeType of the file
 * @returns The resolved item.
 */
var resolveMime = function (mime) {
    var item = data.filter(function (filterItem) { return filterItem.mime.toLowerCase() === mime.toLowerCase(); })[0];
    if (item) {
        return item;
    }
    throw new Error("\n    Mimetype (".concat(mime, ") doesn't exist in our collection, please raise a Request to add the same.\n\n    Please add it to - https://github.com/kirananto/friendly-mimes/blob/master/src/data.ts "));
};
exports.resolveMime = resolveMime;
/**
 * Resolves File type (.mp4, .mp3 etc) of the mime to the specific mime.
 * @param fileType FileType of the file
 * @returns The resolved item.
 */
var resolveFileType = function (fileType) {
    var item = data.filter(function (filterItem) { return filterItem.fileType.toLowerCase() === fileType.toLowerCase(); })[0];
    if (item) {
        return item;
    }
    throw new Error("FileType (".concat(fileType, ") doesn't exist in our collection, please raise a Request to add the same.\n\n    Please add it to - https://github.com/kirananto/friendly-mimes/blob/master/src/data.ts"));
};
exports.resolveFileType = resolveFileType;
/**
 * Resolves name of the mime to array of related mimes.
 * @param name Name of the file
 * @returns Array of related items.
 */
var resolveName = function (name) {
    var items = data.filter(function (filterItem) {
        return filterItem.name.toLowerCase().includes(name.toLowerCase());
    });
    if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
        return items;
    }
    throw new Error("Name (".concat(name, ") doesn't exist in our collection, please raise a Request to add the same.\n\n    Please add it to - https://github.com/kirananto/friendly-mimes/blob/master/src/data.ts"));
};
exports.resolveName = resolveName;
exports.default = {
    resolveName: exports.resolveName,
    resolveMime: exports.resolveMime,
    resolveFileType: exports.resolveFileType
};
